import type { ImportJob } from "../types/import";

export function formatProcessingTime(
  startTime: string,
  endTime: string
): string {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffMs = end.getTime() - start.getTime();

  const minutes = Math.floor(diffMs / 60000);
  const seconds = Math.floor((diffMs % 60000) / 1000);

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}

export function formatProcessingRate(
  totalRows: number,
  startTime: string,
  endTime?: string
): string {
  if (!endTime) return "0";

  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffSeconds = (end.getTime() - start.getTime()) / 1000;

  if (diffSeconds === 0) return "0";

  const rate = totalRows / diffSeconds;
  return rate.toFixed(0);
}

export function calculateEstimatedTime(job: ImportJob): string {
  if (job.total_rows === 0 || job.processed_rows === 0) return "Calculating...";

  const startTime = new Date(job.start_time).getTime();
  const currentTime = new Date().getTime();
  const elapsedMs = currentTime - startTime;

  const processingRate = job.processed_rows / (elapsedMs / 1000); // rows per second
  const remainingRows = job.total_rows - job.processed_rows;

  if (processingRate === 0) return "Calculating...";

  const remainingSeconds = remainingRows / processingRate;

  if (remainingSeconds < 60) {
    return `${Math.ceil(remainingSeconds)} seconds`;
  } else if (remainingSeconds < 3600) {
    return `${Math.ceil(remainingSeconds / 60)} minutes`;
  } else {
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.ceil((remainingSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }
}
